module.exports = __webpack_public_path__ + "static/media/edit.eb9cee0e.svg";